export const getSelectHostName = (value, locale_mapping) => {
  const hostname = window.location.hostname;
  const localeAU = locale_mapping.find((loc) => loc.alias === 'au');
  const localeNZ = locale_mapping.find((loc) => loc.alias === 'nz');
  let selectHostName;
  if (localeAU.locale === value) {
    const indexHostname = localeNZ.hosts.indexOf(hostname);
    selectHostName =
      indexHostname !== -1 ? localeAU.hosts[indexHostname] : localeAU.hosts[0];
  } else {
    const indexHostname = localeAU.hosts.indexOf(hostname);
    selectHostName =
      indexHostname !== -1 ? localeNZ.hosts[indexHostname] : localeNZ.hosts[0];
  }
  return selectHostName;
};
